export const COUNTERTOP_PLACEHOLDER = 0;
export const COUNTERTOP_MINIMUM_OVERHANG = -99;
